import React from "react";
import { Spinner as ReactstrapSpinner } from "reactstrap";
import "./spinner.scss";

function Spinner() {
  const { msg, ...rest } = this.props;
  return (
    <div className="spinner text-center">
      <ReactstrapSpinner {...rest} />
      <div>
        <small>{msg}</small>
      </div>
    </div>
  );
}

export { Spinner };
